import React from 'react'

const Spinner = () => {
  return (
    <div className='spinner center'>
    </div>
  )
}

export default Spinner
